module.exports = __webpack_public_path__ + "static/media/Donations_4.c3333991.jpg";